(function (global) {
  global.menuInit = function menuInit(option) {
    function appendMoreBtn(arr) {
      var moreBtn = document.createElement('div')
      moreBtn.classList.add('menu_item')
      moreBtn.classList.add('more_btn')
      let a = document.createElement('a')
      a.innerHTML = i18n.t('更多')
      moreBtn.append(a)
      var moreList = document.createElement('div')
      moreList.classList.add('nav_menu_list_dorpdown')
      for (var i = 0; i < arr.length; i++) {
        var el = arr[i]
        moreList.prepend(el)
      }
      jQuery(moreBtn).append(moreList)
      jQuery(option.child).append(moreBtn)
      return moreList
    }
    let originArr = jQuery(option.child + ' .menu_item')
    let moreListDom
    function autoMenuInit() {
      moreListDom && moreListDom.remove()
      jQuery(option.child).html('')
      jQuery(option.child).append(originArr)
      jQuery(option.child).css({ opacity: 1 })
      let arr = []
      while (parseInt(jQuery(option.parent).width()) < parseInt(jQuery(option.child).width())) {
        let children = jQuery(option.child + ' .menu_item')
        if (!children || !children.length) return
        arr.push(children[children.length - 1])
        children[children.length - 1].remove()
        if (parseInt(jQuery(option.parent).width()) >= parseInt(jQuery(option.child).width())) {
          moreListDom = appendMoreBtn(arr)
          break;
        }
      }
    }
    // global.autoMenuInit = autoMenuInit
    jQuery(function () {
      if (global.Vue) {
        global.Vue.nextTick(() => {
          let maxTimes = 1200//尝试2分钟1200次
          let times = 0
          let interval = setInterval(() => {
            times++
            //每100ms判断一次
            if (times > maxTimes || !jQuery('[v-cloak]').length) {
              clearInterval(interval)
              autoMenuInit()
            }
          }, 100)
        })
      } else {
        autoMenuInit()
      }
    });
    global.addEventListener('resize', function () {
      autoMenuInit()
    })
  }
  // setTimeout(() => {
  //   menuInit()
  // }, 500);
})(window)